import Modal from "components/elements/Dialog/Modal";
import { useCurrentProject } from "lib/hooks/useProject";
import AutodeskImportBrowser from "./AutodeskImportBrowser";

export default function AutodeskImportModal(p: {
  isOpen: boolean;
  onClose(): void;
}) {
  const { projectId, project } = useCurrentProject();

  return (
    <Modal
      isOpen={p.isOpen && !!project}
      onClose={p.onClose}
      disableSizing
      className="w-full overflow-hidden p-8 sm:max-w-4xl"
    >
      <AutodeskImportBrowser
        projectId={projectId}
        workspaceId={project?.workspace.id}
        onClose={p.onClose}
      />
    </Modal>
  );
}
